
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Tabs, Tab, Paper
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
// import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState, parseSavedData } from '../../../helpers/form';
import dayjs from 'dayjs';
import { useHistory, useLocation, useParams } from "react-router-dom";
import IosShareIcon from '@mui/icons-material/IosShare';
import PropTypes from 'prop-types';
const { Manager } = require("socket.io-client");


var advancedFormat = require('dayjs/plugin/advancedFormat')
dayjs.extend(advancedFormat)

const API_HOST = CONFIG.modules['accounts'].host

const titleMap = {
    'full': 'Full day leave request',
    'half':'Half day leave request',
    'shift': 'Shift swap request'
}
const leaveTypes = ['Sick Leave', 'FMLA', 'Bereavement Leave', 'Paternity Leave', 'Marriage Leave', 'Maternity Leave', 'Casual Leave', 'Earned Leave', 'Loss Of Pay Leave', 'Compensatory Off', 'Others'].map(l => ({ id: l, name: l }))

const fields =
{
    'full': [
        {
            type: 'select',
            label: 'Type',
            required: true,
            name: 'type',
            option: { key: 'LeaveType', value: '_id', label: 'name' }

        },
        {
            type: 'group',
            items: [
                {
                    type: 'date',
                    label: 'From',
                    required: true,
                    name: 'from',
                    defaultValue: dayjs(),
                    parse: (d) => dayjs(d)
                },
                {
                    type: 'date',
                    label: 'To',
                    required: true,
                    name: 'to',
                    defaultValue: dayjs(),
                    parse: (d) => dayjs(d)
                },
            ]
        },
        {
            type: 'text',
            label: 'Description',
            required: true,
            name: 'description',
            multiline: 4
        },
    ],
    'half': [
        {
            type: 'date',
            label: 'Date',
            required: true,
            name: 'forDate',
            defaultValue: dayjs(),
            parse: (d) => dayjs(d)
        },
        {
            type: 'group',
            items: [
                {
                    type: 'time',
                    label: 'Time Off From',
                    required: true,
                    name: 'timeOffFrom',
                    defaultValue: dayjs(),
                    parse: (d) => dayjs(d)
                },
                {
                    type: 'time',
                    label: 'Time Off To',
                    required: true,
                    name: 'timeOffTo',
                    defaultValue: dayjs().add(4,'hour'),
                    parse: (d) => dayjs(d).add(4,'hour')
                },
            ]
        },
      
        // {
        //     type: 'group',
        //     items: [
        //         {
        //             type: 'date',
        //             label: 'From',
        //             required: true,
        //             name: 'from',
        //             defaultValue: dayjs(),
        //             parse: (d) => dayjs(d)
        //         },
        //         {
        //             type: 'date',
        //             label: 'To',
        //             required: true,
        //             name: 'to',
        //             defaultValue: dayjs(),
        //             parse: (d) => dayjs(d)
        //         },
        //     ]
        // },

        {
            type: 'text',
            label: 'Description',
            required: true,
            name: 'description',
            multiline: 4
        },
    ],
    'shift': [
        {
            type: 'date',
            label: 'Date',
            required: true,
            name: 'forDate',
            defaultValue: dayjs(),
            parse: (d) => dayjs(d)
        },
        {
            type: 'select',
            label: 'Current Shift',
            required: true,
            name: 'currentShift',
            option: { key: 'assignedShifts', value: '_id', label: 'name' }

        },
        // {
        //     type: 'select',
        //     label: 'Swap with',
        //     required: true,
        //     name: 'swapWith',
        //     option: { key: 'AvailableUSers', value: '_id', label: 'name' }

        // },
        {
            type: 'select',
            label: 'Select Shift',
            required: true,
            name: 'selectShift',
            option: { key: 'AvailableShifts', value: '_id', label: 'name' }

        },
        {
            type: 'select',
            label: 'Swap with',
            required: true,
            name: 'swapWithAgent',
            option: { key: 'AvailableAgents', value: '_id', label: 'name' }

        },
        // {
        //     type: 'group',
        //     items: [
        //         {
        //             type: 'select',
        //             label: 'Current Shift',
        //             required: true,
        //             name: 'currentShift',
        //             option: { key: 'assignedShifts', value: '_id', label: 'name' }
        
        //         },
        //         {
        //             type: 'select',
        //             label: 'Desired Shift',
        //             required: true,
        //             name: 'appliedShift',
        //             option: { key: 'Shifts', value: '_id', label: 'name' }
        
        //         },
        //     ]
        // },

        {
            type: 'text',
            label: 'Description',
            required: true,
            name: 'description',
            multiline: 4
        },
    ]
};

const items = {
    'Apply Leave': {
        name: 'Apply Leave',
        view: ''
    },

}
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}



export const MyLeaves = (props) => {
    let socket;
    const [value, setValue] = useState(0);
    const [balance, setBalance] = useState(null);
    const {
        user,
		map,
	} = useSelector((state) => state.user || {});
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

   

    useEffect(()=>{
        if (user) {
            const manager = new Manager(CONFIG.modules['accounts'].socket, {
                reconnectionDelayMax: 10000,
                path: "/accounts"
            });

            socket = manager.socket("/common", {
                query: {
                    token: localStorage.getItem('authToken') || ''
                }
            });

            socket.on(`${user._id}-leave-balance`, ({data}) => {
                if (data) {
                    setBalance(data)
                }

            })

        }
    },[user])

    useEffect(() => {
        return () => {
            if (socket) {
                socket.removeAllListeners();
            }
        }
    }, [])

    useEffect(() => {
        fetchLeaveBalance()
    }, [])



    const fetchLeaveBalance = () => {
        axios.get(API_HOST + `/leave-balance`).then((resp) => {
            if (resp.data && resp.data.success) {
                setBalance(resp.data.leaveBalance)
            }
        }).catch((e) => {
            console.log(e)
        })
    }
    return (
        <Box sx={{ width: '100%' }}>
            {
                balance &&
                <Box sx={{ p:2, display: 'flex'}}>
                    <Paper sx={{p:2, ml:1, display: 'flex', alignItems: 'center'}}>
                        <Typography sx={{fontSize: 13, color: '#183b56'}}>Leaves Taken: &nbsp;</Typography> <Typography sx={{fontSize: 15, color: '#375674'}}> {`${balance.taken}`}</Typography>
                    </Paper>
                    <Paper sx={{p:2, ml:1, display: 'flex', alignItems: 'center'}}>
                        <Typography sx={{fontSize: 13, color: '#183b56'}}>Leaves Remaining: &nbsp;</Typography> <Typography sx={{fontSize: 15, color: '#375674'}}>  {`${balance.alloted-balance.taken} / ${balance.alloted}`}</Typography>
                    </Paper>
                </Box>
            }

            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Full Day Leave" {...a11yProps(0)} />
                    <Tab label="Half Day Leave" {...a11yProps(1)} />
                    <Tab label="Shift Swapping" {...a11yProps(2)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}  >
                <List type={'full'} balance={balance} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}  >
                <List type={'half'} balance={balance} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}  >
                <List type={'shift'}  balance={balance}/>
            </CustomTabPanel>
        </Box>
    )
}

export const List = ({ type, balance }) => {

    const fullDayLeaveForm = [
        {
            id: '_id', label: 'Date of Leave', minWidth: 120, format: (data, row) => {
                return `${dayjs(row.from).format('Do MMM')} to ${dayjs(row.to).format('Do MMM')}`
            }
        },
        { id: 'type', label: 'Type ', minWidth: 120 },
        { id: 'description', label: 'Details', minWidth: 170 },
        { id: 'approved', label: 'Status', minWidth: 170 },
        {
            id: 'createdAt', label: 'Application Date', minWidth: 60, format: (data, row) => {
                return data ? dayjs(data).format('Do MMM') : ''
            }
        },

    ];

    const halfDayLeaveForm = [
        {
            id: '_id', label: 'Time of Leave', minWidth: 120, format: (data, row) => {
                return `${dayjs(row.forDate).format('Do MMM')} (${dayjs(row.timeOffFrom).format('hh:mm a')}-${dayjs(row.timeOffFrom).format('hh:mm a')})`
            }
        },
        { id: 'description', label: 'Details', minWidth: 170 },
        { id: 'approved', label: 'Status', minWidth: 170 },
        {
            id: 'createdAt', label: 'Application Date', minWidth: 60, format: (data, row) => {
                return data ? dayjs(data).format('Do MMM') : ''
            }
        },

    ];

    const shiftSwappingForm = [
        // {
        //     id: '_id', label: 'Shift', minWidth: 120, format: (data, row) => {
        //         return `${dayjs(row.from).format('Do MMM')} to ${dayjs(row.to).format('Do MMM')}`
        //     }
        // },
        {
            id: '_id', label: 'For Date', minWidth: 120, format: (data, row) => {
                return `${dayjs(row.forDate).format('Do MMM')} `
            }
        },
        {
            id: 'currentShiftName', label: 'Current Shift', minWidth: 120, format: (data, row) => {
                return data?data:''
                //`${shiftMap[data.shift]?.name} (${dayjs(shiftMap[data.shift].start).format('hh:mm a')} - ${dayjs(shiftMap[data.shift].end).format('hh:mm a')})`:''
            }
        },
        {
            id: 'selectShift', label: 'Applied Shift', minWidth: 120, format: (data, row) => {
                return data&&data.shift?map.Shifts[data.shift].name:""
            }
        },
        {
            id: 'swapWithAgent', label: 'Swap request To', minWidth: 120, format: (data, row) => {
                return data&&data.user?map.users[data.user].name:''
            }
        },
        // {
        //     id: 'appliedShift', label: 'Desired Shift', minWidth: 120, format: (data, row) => {
        //         return data?`${data.name } (${(dayjs(data.start).format('hh:mm a'))}-${(dayjs(data.end).format('hh:mm a'))})`:''
        //     }
        // },
        { id: 'description', label: 'Details', minWidth: 170 },
        { id: 'approved', label: 'Status', minWidth: 170 },
        {
            id: 'createdAt', label: 'Application Date', minWidth: 60, format: (data, row) => {
                return data ? dayjs(data).format('Do MMM') : ''
            }
        },
    ];

    const { roles, user, users, Designations, Departments, Languages, Districts, map, Shifts, LeaveType } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))

    const history = useHistory();
    const location = useLocation()


    const [active, setActive] = useState('My Leave Applications')
    const [data, setData] = useState(users || [])
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('new')
    const [saved, setSaved] = useState(null);
    const [index, setIndex] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false)
    const [formData, setFormData] = useState(getFormState(fields[type]))
    const [filter, setFilter] = useState({
        date: dayjs()
    })
    const [currentForm, setCurrentForm] = useState(fullDayLeaveForm);
    const [myAssignedShifts, setMyAssignedShifts] = useState([])
    const [assignedShifts, setAssignedshifts] = useState([])
    const [availableAgentsbyShift, setAvailableAgentsbyShift] = useState([])
    const [openConfirmCancel,setOpenConfirmCancel] = useState(false)
    const [toCancelLeave, setToCancelLeave] = useState(null)



    useEffect(()=>{
        // console.log(value)
        if((type=="shift" || type == 'half') && formData.forDate) {
            fetchMyAssignedLeaves()
        }
    },[type, formData.forDate])

    useEffect(()=> {
        if(type == 'half'&& myAssignedShifts.length>0) {
            const {shift} = myAssignedShifts[0]
            formData['timeOffFrom'] = dayjs(shift.start)
            formData['timeOffTo'] = dayjs(shift.start).add(4,'hour')
            setFormData({...formData})
            console.log('--------------------->',myAssignedShifts[0])
        }
    },[myAssignedShifts])

    useEffect(()=>{
        if(formData.forDate && formData.currentShift )
        fetchAssignedShifts()
    },[formData.currentShift])

    useEffect(()=>{
        if(formData.forDate && formData.currentShift && formData.selectShift)
        fetchAgentsOfShift()
    }, [formData.selectShift])

    const fetchAgentsOfShift = () => {
        axios.get(API_HOST + `/get-agents-by-shifts?schedule=${formData.selectShift}`).then((resp) => {
            if (resp.data && resp.data.success) {
                setAvailableAgentsbyShift(resp.data.data.map(d=>{
                    return {
                        _id: d._id, name: d.user.name
                    }
                }))
            } else {
                
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const fetchAssignedShifts = () => {
        axios.get(API_HOST + `/assigned-shifts-by-date?forDate=${formData.forDate.format('YYYY-MM-DD')}`).then((resp) => {
            if (resp.data && resp.data.success) {
                setAssignedshifts(resp.data.data.map((d)=>{
                    return {_id: d._id, name: d.shift.name, shiftId: d.shift._id}
                }))
            } else {
                
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    useEffect(()=>{
        console.log('mm', myAssignedShifts)
    }, [myAssignedShifts])


    const fetchMyAssignedLeaves = () => {
        axios.get(API_HOST + `/my-assigned-shifts?forDate=${formData.forDate.format('YYYY-MM-DD')}`).then((resp) => {
            if (resp.data && resp.data.success) {
                // const shiftMap = map.Shifts
                // console.log(shiftMap)
                // const assignedLeavesComposed = resp.data.data.filter(e=>shiftMap[e.shift]).map((e)=> {
                    // return {...e, name: `${shiftMap[e.shift]?.name} (${dayjs(shiftMap[e.shift]?.start).format('hh:mm a')} - ${dayjs(shiftMap[e.shift]?.end).format('hh:mm a')}) 
                    // (${dayjs(e.from).format('DD/MM/YYYY')} - ${dayjs(e.to).format('DD/MM/YYYY')})`}
                //     return {...e, name: `${shiftMap[e.shift]?.name} (${dayjs(shiftMap[e.shift]?.start).format('hh:mm a')} - ${dayjs(shiftMap[e.shift]?.end).format('hh:mm a')}) 
                //     `}
                // })
                setMyAssignedShifts(resp.data.data.map(d=> {
                    return { shift: d.shift,_id: d._id, scheduleId: d.schedule._id, name: `${d.shift.name} (${dayjs(d.shift.start).format('hh:mm a')}-${dayjs(d.shift.end).format('hh:mm a')})`}
                }))
            } else {
                setMyAssignedShifts([])
            }
        }).catch((e) => {
            console.log(e)
        })
    }


    // const exportReport = (date, range) => {
    //     const callDate = dayjs(date).format('YYYY-MM-DD')

    //     axios.get(API_HOST + `/ecd/export?user=${user._id}${
    //         filter.from?`&from=${dayjs(filter.from).format('YYYY-MM-DD')}`:''
    //         }${filter.to?`&to=${dayjs(filter.to).format('YYYY-MM-DD')}`:''}
    //         ${filter.status?`&status=${filter.status}`:''}`, {
    //         responseType: 'arraybuffer',
    //     })
    //         .then((resp) => {
    //             if (resp) {
    //                 const url = window.URL.createObjectURL(new Blob([resp.data]));
    //                 const link = document.createElement('a');
    //                 link.href = url;
    //                 link.setAttribute('download', `ECD_Report_${dayjs(filter.from).format('DD-MM-YYYY')}-${dayjs(filter.to).format('DD-MM-YYYY')}.xlsx`);
    //                 document.body.appendChild(link);
    //                 link.click();
    //                 console.log(resp)
    //                 link.remove()
    //             }

    //         }).catch((e) => {

    //             console.log(e)
    //         })


    // }



    const fetchLeaves = () => {
        axios.get(API_HOST + `/my-leave?leaveType=${type}`).then((resp) => {
            if (resp.data && resp.data.success) {
                setData(resp.data.data.map((u) => {
                    const shiftMap = map.Shifts
                    if(u.currentShift) {
                        u.currentShiftName = `${shiftMap[u.currentShift.shift]?.name} (${dayjs(shiftMap[u.currentShift.shift]?.start).format('hh:mm a')} - ${dayjs(shiftMap[u.currentShift.shift]?.end).format('hh:mm a')})
                        
                        (${dayjs(u.currentShift.from).format('DD/MM/YYYY')} - ${dayjs(u.currentShift.to).format('DD/MM/YYYY')})`
                    }
                    return u
                }))
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    useEffect(() => {
        if (location && location.search.includes('open=true')) {
            setOpen(true)
        }
    }, [])

    useEffect(() => {
        fetchLeaves()
    }, [filter.date])

    useEffect(() => {
        fetchLeaves()
    }, [active])

    useEffect(() => {
        // console.log('dd', Designations)
    }, [Designations])

    useEffect(() => {
        // console.log(userStore)
    }, [userStore])

    useEffect(() => {
        if (type === 'half') {
            setCurrentForm(halfDayLeaveForm)
        } else if (type === 'shift') {
            setCurrentForm(shiftSwappingForm)
        } else {
            setCurrentForm(fullDayLeaveForm)
        }
    }, [type])

    const exportLeavesByUser = (id, name) => {
        axios.get(API_HOST + `/export-leaves-by-agent?user=${id}`, {
            responseType: 'arraybuffer'
        }).then((resp) => {
            if (resp) {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Leave_Report_${name || id}.xlsx`);
                document.body.appendChild(link);
                link.click();
                console.log(resp)
                link.remove()
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const handleSubmit = () => {

        axios.post(API_HOST + '/leave', {
            payload: { ...formData, user: user._id, leaveType: type }
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpen(false)
                setData([resp.data.data, ...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const handleEdit = (id, status) => {

        axios.put(API_HOST + `/leave/${data[id]._id}`, {
            status
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                data[id] = resp.data.data;
                setData([...data]);
                setOpenConfirmCancel(false)

            }
        }).catch((e) => {
            console.log(e)
        })
    }
    const handleLeaveEdit = () => {
        const payload = { ...formData }

        axios.put(API_HOST + `/leave-update/`, {
            payload
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                const newData = data.map(d => {
                    if (d._id === payload._id) {
                        return resp.data.data
                    } else {
                        return d
                    }
                })
                setData([...newData]);
                setOpen(false);
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const handleDelete = () => {
        axios.delete(API_HOST + '/' + saved._id).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpenConfirm(false)
                data.splice(index, 1)
                setData([...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    return (
        <>
            {/* <Tabs items={items} active={active} onChange={(key) => {
                setActive(key)
            }} /> */}
            <ToolBar name={active} buttons={[
                {
                    name: 'Add new leave',
                    onClick: () => {
                        setAction('new')
                        setFormData(getFormState(fields[type]))
                        setOpen(true)
                    }
                },
                {
                    name: 'Export Report',
                    // type: 'chip',
                    icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
                    onClick: () => {
                        exportLeavesByUser(user._id, user.name)
                    }
                }
            ]}
            // filters={[
            //     {
            //         field: {
            //             name: 'date',
            //             type:'date',
            //             label:'Date',
            //         },
            //         onChange: (name, value) => {
            //             filter[name] = value
            //             setFilter({...filter})
            //         },
            //         state: filter

            //     }
            // ]} 
            />
            <Box sx={{ mt: 2 }}>
                <Grid data={data} columns={currentForm}
                    actions={[
                        {
                            name: 'Cancel',
                            showIf: {
                                key: 'approved',
                                values: ['Pending', 'Approved']
                            },
                            onClick: (id) => {
                                setOpenConfirmCancel(true)
                                setToCancelLeave(id)

                            }
                        },
                        {
                            name: 'Edit',
                            showIf: {
                                key: 'approved',
                                values: ['Pending']
                            },
                            showFunction: (data) => {
                                return data.approved === 'Pending'
                            },
                            onClick: (id) => {
                                setAction('edit')
                                const newData = { ...data[id] }
                                const parsedData = { ...(parseSavedData(newData, fields[type])) }
                                setFormData(parsedData)
                                setSaved(data[id])
                                setOpen(true)
                            }
                        }
                    ]}
                ></Grid>
            </Box>
            <Modal open={open}
                handleClose={() => { setOpen(false) }}
                head={titleMap[type]||''}
                // head={`${action == 'new' ? 'Leave Request' : 'Edit Leave Request'}`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpen(false)
                        }
                    },
                    {
                        name: action == 'new' ? 'Create' : 'Save',
                        onClick: () => {
                            switch (action) {
                                case 'new':
                                    handleSubmit()
                                    break;
                                case 'edit':
                                    handleLeaveEdit()
                                    break;
                                default: break;
                            }
                        }
                    }
                ]}

            >
                {
                    action == 'edit' &&
                    <Typography variant='p' color="grey">{
                        'ID: ' + saved._id
                    }</Typography>
                }
                  {
                    balance &&
                    <Box sx={{ p:2, display: 'flex'}}>
                        <Paper sx={{p:2, ml:1, display: 'flex', alignItems: 'center'}}>
                            <Typography sx={{fontSize: 13, color: '#183b56'}}>Leaves Taken: &nbsp;</Typography> <Typography sx={{fontSize: 15, color: '#375674'}}> {`${balance.taken}`}</Typography>
                        </Paper>
                        <Paper sx={{p:2, ml:1, display: 'flex', alignItems: 'center'}}>
                            <Typography sx={{fontSize: 13, color: '#183b56'}}>Leaves Remaining: &nbsp;</Typography> <Typography sx={{fontSize: 15, color: '#375674'}}>  {`${balance.alloted-balance.taken} / ${balance.alloted}`}</Typography>
                        </Paper>
                    </Box>
                }
                {
                    currentForm && Array.isArray(fields[type]) &&
                    <Box sx={{ mt: 2 }}>
                        <FormA fields={fields[type]}
                            data={{ 
                                AvailableAgents: availableAgentsbyShift,
                                LeaveType, AvailableShifts: assignedShifts.filter((e)=>{
                                    const obj = myAssignedShifts.find(d=>d._id == formData.currentShift)
                                return formData.currentShift&&obj?(e._id !=obj.scheduleId):true
                            }), assignedShifts:myAssignedShifts, Shifts, AvailableUSers: (users || []).filter((u) =>
								(u.roles || []).includes(process.env.REACT_APP_TELECALLER)
							) }}
                            onChange={(name, value, multiple) => {
                                formData[name] = value
                                setFormData({ ...formData })
                            }}
                            state={formData || {}}
                        />
                    </Box>
                }


            </Modal>

            <Modal open={openConfirmCancel}
                handleClose={() => { setOpenConfirmCancel(false) }}
                head={`Cancel Leave`}
                desc={`Please confirm to cancel this leave.`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpenConfirmCancel(false)
                        }
                    },
                    {
                        name: 'Confirm',
                        onClick: () => {
                            handleEdit(toCancelLeave, 'Withdrawn')

                        }
                    }
                ]}

            >
                {/* {
                    saved &&
                    <Box>
                        <Typography variant='p' color="grey">{'ID: ' + saved._id}</Typography><br></br>
                        <Typography variant='p' color="grey">{'Name: ' + saved.name}</Typography>
                    </Box>
                } */}

            </Modal>

            <Modal open={openConfirm}
                handleClose={() => { setOpen(false) }}
                head={`${'Delete'} ${active}`}
                desc={`Please confirm to delete the following ${active}?`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpenConfirm(false)
                        }
                    },
                    {
                        name: 'Delete',
                        onClick: () => {
                            handleDelete()
                        }
                    }
                ]}

            >
                {
                    saved &&
                    <Box>
                        <Typography variant='p' color="grey">{'ID: ' + saved._id}</Typography><br></br>
                        <Typography variant='p' color="grey">{'Name: ' + saved.name}</Typography>
                    </Box>
                }

            </Modal>
        </>
    )
}